export default {
  startingLineups: {
    title: "Formations partantes",
    labels: {
      confirmed: "CONFIRMÉ",
      expected: "PRÉVU",
      tbd: "À DÉTERMINER",
      noLineupAvailable: "Aucune formation disponible",
    },
    empty: {
      title: "Aucune formation disponible",
    },
  },
};
